import Vue from 'vue'
import Vuex from 'vuex'

//挂载Vuex
Vue.use(Vuex)

//创建VueX对象
const store = new Vuex.Store({
    state:{
        //存放的键值对就是所要管理的状态
        user : [],
        tuzhiList : [],
        liandanList : [],
        shenSkillList : [],
        materialList : [],
        weaponType: "",
        responsive: {
          width: 1200,
          height: 800,
          isMobile: false,
          isTablet: true,
        },
    },
    mutations:{
        //es6语法，等同edit:funcion(){...}
        edit(state,val){
            state.user = val
        },
        setZhuList(state, value) {
          state.tuzhiList = value;
        },
        setLianList(state, value) {
          state.liandanList = value;
        },
        setZhenList(state, value) {
          state.shenSkillList = value;
        },
        setMaterialList(state, value) {
          state.materialList = value;
        },
        setWeaponType(state, value) {
          state.weaponType = value;
        },
        setResponsive(state, payload) {
          state.responsive = {
            ...state.responsive,
            ...payload
          };
        },
        setIsMobile(state, value) {
          state.responsive = {
            ...state.responsive,
            isMobile: !!value
          };
        }
    }
})

export default store




// WEBPACK FOOTER //
// ./src/store/store.js